// LayoutEditorSlotMenu.jsx

import React from 'react';

// CSS
import './LayoutEditorSlotMenu.css';

// Components
import PopupOption from 'components/popup/option/PopupOption';
import Popup from 'components/popup/Popup';

/**
 * LayoutEditorSlotMenu
 *
 * Renders the slot action popup menu for the active slot or container context.
 *
 * @param {object} anchorRef - Ref used to anchor the popup.
 * @param {boolean} isOpen - Whether the popup is currently open.
 * @param {object|null} menuState - Current menu label, actions, and node context.
 * @param {function} setOpen - Function used by Popup to open or close the menu.
 *
 * @returns {ReactNode} The rendered slot action menu.
 */
const LayoutEditorSlotMenu = ({
	anchorRef,
	isOpen = false,
	menuState = null,
	setOpen,
}) => {

	// ----- CONTEXT ----- //

	const menuLabel = String(menuState?.label || '').trim() || 'Block Actions';
	const actions = Array.isArray(menuState?.actions) ? menuState.actions : [];
	const menuNodeKey = String(menuState?.nodeKey || 'menu').trim() || 'menu';
	// ----- RENDER ----- //

	return (
		<Popup anchorRef={anchorRef} isOpen={isOpen} setOpen={setOpen}>
			<div className="layout-editor-slot-menu-container">
				{/* LABEL */}
				<div
					className="layout-editor-slot-menu-label"
				>
					{menuLabel}
				</div>

				{/* ACTIONS */}
				<div className="layout-editor-slot-menu-actions">
					{actions.map((action) => {
						const actionLabel = String(action?.label || '').trim();
						if (!actionLabel) return null;

						return (
							<PopupOption
								key={`${menuNodeKey}:${actionLabel}`}
								disabled={action?.disabled === true}
								label={actionLabel}
								onClick={action?.onClick}
							/>
						);
					})}
				</div>
			</div>
		</Popup>
	);
};

// Dev Tools
LayoutEditorSlotMenu.displayName = 'LayoutEditorSlotMenu';

export default LayoutEditorSlotMenu;
